import { jsx } from "react/jsx-runtime";
import { useRef, useLayoutEffect, useEffect } from "react";
const Widget = ({
  fieldId,
  widgetHtml,
  value,
  onChange
}) => {
  const iframeRef = useRef(null);
  const onChangeRef = useRef(onChange);
  useLayoutEffect(() => {
    onChangeRef.current = onChange;
  });
  const valueRef = useRef(value);
  useLayoutEffect(() => {
    valueRef.current = value;
  });
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.fieldId !== fieldId) {
        return;
      }
      if (event.data.type === "READY") {
        iframeRef.current?.contentWindow?.postMessage(
          { type: "INIT", fieldId, value: valueRef.current ?? {} },
          "*"
        );
      }
      if (event.data.type === "HEIGHT_CHANGED") {
        if (iframeRef.current) {
          iframeRef.current.style.height = `${event.data.height}px`;
        }
      }
      if (event.data.type === "VALUE_CHANGED") {
        onChangeRef.current(event.data.value);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [fieldId]);
  return /* @__PURE__ */ jsx(
    "iframe",
    {
      ref: iframeRef,
      title: "Widget",
      sandbox: "allow-scripts",
      srcDoc: widgetHtml.replace("{{FIELD_ID}}", fieldId),
      style: { border: "none", width: "100%", height: "100%" }
    }
  );
};
export {
  Widget
};
//# sourceMappingURL=widget.js.map
